import { isArray } from "lodash";
import { IRadioBlockItem } from "common/components/RadioBlockItem/RadioBlockItem";

// Générique pour rendre le composant flexible
type IValue<T> = T | T[];
interface IRadioBlock<T> {
  items: Array<Omit<IRadioBlockItem, "id"> & { id: T }>;
  onChange?: (id: IValue<T>) => void;
  multiple?: boolean;
  value?: IValue<T>;
  Component: React.ElementType;
  horizontal?: boolean;
  noGap?: boolean;
  disabled?: boolean;
}

const getSelected = <T,>(
  itemValue: T,
  value?: IValue<T>,
  multiple?: boolean
): boolean => {
  if (!multiple && value === undefined) {
    return false;
  }
  if (!multiple) {
    return itemValue === value;
  }
  return isArray(value) && value.includes(itemValue);
};

function RadioBlock<T>({
  items,
  value,
  onChange,
  multiple,
  Component,
  horizontal = false,
  noGap = false,
  disabled = false,
}: IRadioBlock<T>) {
  const onClick = (itemValue: T) => {
    if (disabled || !onChange) {
      return;
    }

    if (!multiple) {
      onChange(itemValue);
      return;
    }

    if (isArray(value) && value?.includes(itemValue)) {
      onChange(value.filter((v) => v !== itemValue));
      return;
    }

    if (isArray(value)) {
      onChange([...value, itemValue]);
    }
  };

  return (
    <div
      className={`${horizontal ? "flex flex-wrap w-full" : "flex flex-col"} ${
        !noGap && "gap-3 w-full"
      } ${disabled ? "opacity-75" : ""}`}
    >
      {items.map((item) => (
        <Component
          key={String(item.id)}
          onClick={() => onClick(item.id)}
          selected={getSelected(item.id, value, multiple)}
          disabled={disabled}
          {...item}
        />
      ))}
    </div>
  );
}

export default RadioBlock;
